export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('form_label_displayStore') || '店铺',
    field: 'amzStoreNo',
    minWidth: 200,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayStore' },
  },
  {
    title: that.$l('form_label_displayAccount') || '账号',
    field: 'amzStoreName',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayAccount' },
  },
  {
    title: that.$l('form_label_invStoreCode') || '库存店铺',
    field: 'invStoreName',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayInvStoreName' },
  },
  {
    title: that.$l('form_label_managerName') || '店长名字',
    field: 'managerName',
    width: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_ecomCompanyName') || '申请公司',
    field: 'ecomCompanyName',
    width: 220,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayEcomCompanyName' },
  },
  {
    title: that.$l('form_label_loginMobile') || '登录手机',
    field: 'mobile',
    width: 220,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayMobile' },
  },
  {
    title: 'IP',
    field: 'IP',
    width: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayIP' },
  },
  {
    title: that.$l('form_label_creditCard') || '信用卡',
    field: 'creditCard',
    width: 220,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreditCard' },
  },
  {
    title: that.$l('form_label_remark') || '备注说明',
    field: 'remark',
    width: 300,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'left',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'left',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
